module.exports = __webpack_public_path__ + "img/VectorBottom.9830f965.svg";